export const API_TEMPLATES_BASE_URL = import.meta.env.API_TEMPLATES_BASE_URL;
export const DOCS_USER_BASE_URL = import.meta.env.DOCS_USER_BASE_URL;
